import { useEffect, useRef, useState } from "react";
import logo from "../Assets/images/advancederp.png";
import { EYEOPENICON, EYECLOSEICON } from "../Utils/icons";
import { useNavigate } from "react-router-dom";
import { isEmpty, isEmptyArray, isEmptyString } from "../Utils/util.js";
import { RestLoginBean } from "../Ds/ds";
import { ToastContainer, toast } from "react-toastify";
import service from "../Services/Service";
import { SecurityAccessManager } from "../Security/SecurityAccessManager";
import { LogicConstants } from "../Utils/logicConstants";
export default function Login({
  setIsAuthenticated,
  token,
  setToken,
  setisSessionExpeired,
  setSession,
  setEntitlements,
}) {
  const [type, setType] = useState("password");
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [isVisible, setVisible] = useState(false);
  const [error, setError] = useState("");
  const passwordRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    sessionStorage.removeItem("isAuth");
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("sessiondata");
  }, []);

  const notify = (type, msg, theme) => {
    if (type === 1)
      toast.info(msg, {
        theme: theme,
      });
    else if (type === 2)
      toast.error(msg, {
        theme: theme,
      });
    else if (type === 3)
      toast.success(msg, {
        theme: theme,
      });
    else if (type === 4)
      toast.warn(msg, {
        theme: theme,
      });
    else toast(msg);
  };

  const isAdmin = (data) => {
    return data.loginType === LogicConstants.LOGIN_TYPE_ADMIN_USER
      ? true
      : false;
  };

  const isSpecialUser = (data) => {
    return data.loginType === LogicConstants.LOGIN_TYPE_SPECIAL_DATA_PORTAL_USER
      ? true
      : false;
  };

  const onLoginSuccess = (data) => {
    if (
      !isEmpty(data) &&
      !isEmpty(data.sessionBean) &&
      !isEmptyString(data.sessionBean.securityPass)
    ) {
      setIsAuthenticated(true);
      sessionStorage.setItem("isAuth", true);

      navigate("/home");

      setToken(data.sessionBean.securityPass);
      sessionStorage.setItem("token", data.sessionBean.securityPass);
      setisSessionExpeired(false);

      if (!isAdmin(data.sessionBean)) {
        if (!isSpecialUser(data.sessionBean)) {
          setSession(data.sessionBean);
          sessionStorage.setItem(
            "sessiondata",
            JSON.stringify(data.sessionBean)
          );
        } else {
          const _session = data.sessionBean;
          _session.code = "";
          setSession(_session);
          sessionStorage.setItem("sessiondata", JSON.stringify(_session));
        }
      } else {
        const _session = data.sessionBean;
        _session.entityCode = "";
        _session.code = "";
        setSession(_session);
        sessionStorage.setItem("sessiondata", JSON.stringify(_session));
      }
    }
    if (
      !isEmpty(data) &&
      !isEmpty(data.entitlementPageListResponse) &&
      !isEmptyArray(data.entitlementPageListResponse.entitlementPageList) &&
      !isEmptyArray(
        data.entitlementPageListResponse.entitlementPageList.entitlements
      )
    ) {
      setEntitlements(
        data.entitlementPageListResponse.entitlementPageList.entitlements
      );
      sessionStorage.setItem(
        "entitlements",
        JSON.stringify(
          data.entitlementPageListResponse.entitlementPageList.entitlements
        )
      );
    } else {
      setEntitlements(new Array());
      sessionStorage.setItem("entitlements", JSON.stringify(new Array()));
    }
    SecurityAccessManager.initEntitlements();
  };

  const responseHandler = (response) => {
    let responseData = response.data;
    if (responseData.success) {
      onLoginSuccess(responseData);
    } else {
      setError("Invalid User / Password");
    }
  };

  const errorCallBack = () => {};

  const login = () => {
    const request = new RestLoginBean();
    request.code = userName;
    request.password = password;
    request.companyCode = process.env.REACT_APP_COMPANY;
    const path = "login";
    service(token, path, request, responseHandler, errorCallBack);
  };

  const loginHandler = (e) => {
    e.preventDefault();
    login();
  };

  const setFocus = () => {
    if (passwordRef.current != null) passwordRef.current.focus();
  };

  const toggleHandler = () => {
    setVisible(!isVisible);
    isVisible ? setType("password") : setType("text");
    setFocus();
  };

  return (
    <div className="login-cnt">
      <div className="login-background"></div>
      <div className="login-container">
        <div className="login-wrapper">
          <div className="login-header">
            {process.env.REACT_APP_APP_NAME}-{" "}
            <span className="login-app-version"> V </span>
            {process.env.REACT_APP_GUI_VERSION}
          </div>
          <div className="login-logo">
            <img src={logo} mode="fit" alt="logo" />
          </div>
          <form onSubmit={(e) => loginHandler(e)}>
            <div className="login-input-wrp ">
              <input
                type="text"
                id="username"
                required
                name="userName"
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
                className="form-input"
              />
              <div className="form-cut fc1"></div>
              <label htmlFor="username" className="form-placeholder">
                User
              </label>
            </div>
            <div className="login-pswd-wrp ">
              <input
                type={type}
                required
                name="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="form-input"
                ref={passwordRef}
              />
              <span className="eye-icon" onClick={(e) => toggleHandler(e)}>
                {isVisible ? (
                  <i>
                    <EYEOPENICON />
                  </i>
                ) : (
                  <i>
                    <EYECLOSEICON />
                  </i>
                )}
              </span>
              <div className="form-cut fc2"></div>
              <label htmlFor="password" className="form-placeholder">
                Password
              </label>
            </div>
            <input type="text" value={process.env.REACT_APP_COMPANY} disabled />
            <button
              // onClick={() =>
              //   this.login(appData.serviceURL, appData.companyCode, appData)
              // }
              // type="button"
              type="submit"
              // onClick={(e) => login(e)}
            >
              Login
            </button>
          </form>
          {!isEmptyString(error) ? (
            <div className="form-error">{error}</div>
          ) : null}
          <div className="login-footer">Powered by Advanced ERP USA</div>
        </div>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </div>
  );
}
